<a href="#" class="img-wrapper">
  <img alt="tenant-logo"
       [src]="(profile$ | async)?.logoUrl || 'assets/images/logo/becorps-ver.svg'"/>
</a>
